import { render, staticRenderFns } from "./activity-preview-read-only-questions.vue?vue&type=template&id=e86d940c&scoped=true&"
import script from "./activity-preview-read-only-questions.vue?vue&type=script&lang=js&"
export * from "./activity-preview-read-only-questions.vue?vue&type=script&lang=js&"
import style0 from "./activity-preview-read-only-questions.vue?vue&type=style&index=0&id=e86d940c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e86d940c",
  null
  
)

component.options.__file = "activity-preview-read-only-questions.vue"
export default component.exports